/**
 * @group Constants
 * 
 * @summary
 * <blockquote>Scanner service constants for URL construction and configuration</blockquote>
 * 
 * @example
 * ```typescript
 * import { SCANNER_CONSTANTS } from '@shared/utils';
 * 
 * const serviceName = SCANNER_CONSTANTS.SERVICE_NAME;
 * ```
 */
export const SCANNER_CONSTANTS = {
  /**
   * Service name for scanner API
   */
  SERVICE_NAME: 'scanner',
  /**
   * Default measurement preset sent to the scanner API
   */
  DEFAULT_MEASUREMENT_PRESET: 'thirty_seconds_all_metrics',
  /**
   * Default precision mode sent to the scanner API
   */
  DEFAULT_PRECISION_MODE: 'relaxed',
  /**
   * Sentinel value indicating no real patient has been linked yet
   */
  DEFAULT_PATIENT_ID: 'default-patient-id',
} as const;
